import { Saga } from './workers';

export default Saga;



// WEBPACK FOOTER //
// ./src/redux/responses/get-all/sagas.js